import React from 'react';
import { Phone } from 'lucide-react';
import { heroContent, companyInfo } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const HeroSection = () => {
  const { isDark } = useTheme();

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${heroContent.backgroundImage})`,
        }}
      >
        <div className={`absolute inset-0 ${isDark ? 'bg-gradient-to-r from-neutral-950/80 via-neutral-950/60 to-neutral-950/80' : 'bg-gradient-to-r from-white/90 via-white/75 to-white/90'}`} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 pt-44">
        <div className={`backdrop-blur-sm p-8 md:p-12 rounded-xl ${isDark ? 'bg-neutral-900/80' : 'bg-white/95 shadow-2xl'}`}>
          {/* Call Button */}
          <div className="flex justify-center mb-8">
            <a
              href={`tel:${companyInfo.phone}`}
              className={`inline-flex items-center gap-2 px-12 py-4 border-2 border-lime-500 font-medium text-lg rounded-lg transition-all duration-300 hover:bg-lime-500 hover:text-black ${isDark ? 'text-white' : 'text-neutral-900'}`}
            >
              Call Us
            </a>
          </div>

          {/* Title */}
          <h1 className={`text-3xl md:text-4xl lg:text-5xl font-bold text-center leading-tight ${isDark ? 'text-white' : 'text-neutral-900'}`}>
            {heroContent.title}
          </h1>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className={`w-6 h-10 border-2 rounded-full flex items-start justify-center p-2 ${isDark ? 'border-white/30' : 'border-neutral-400'}`}>
          <div className="w-1.5 h-3 bg-lime-500 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
